import { connect } from 'react-redux';
import LaporanJmlPegawai from '../../views/Settings/LaporanJmlPegawai.view';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import {studentCount, reportTtlStaff, reportTtlStaffPerwakilan,
  reportTtlStaffPerunit
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleReportTtlStaff: (payload, goback) => dispatch(reportTtlStaff(payload, goback)),
    handleReportTtlStaffPerwakilan: (payload, goback) => dispatch(reportTtlStaffPerwakilan(payload, goback)),
    handleReportTtlStaffPerunit: (payload, goback) => dispatch(reportTtlStaffPerunit(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanJmlPegawai);
